import script from "./RegistroView.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistroView.vue?vue&type=script&setup=true&lang=js"

import "./RegistroView.vue?vue&type=style&index=0&id=87ca76c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87ca76c0"]])

export default __exports__